<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <card shadow type="secondary">
                    <div slot="header" class="bg-white border-0">
                        <div class="row align-items-center">
                            <div class="col-8">
                                <h3 class="mb-0">Diagnosis</h3>
                            </div>
                        </div>
                    </div>
                    <template>
                        <div class="row custom-gutter">
                            <div class="form-group col-md-3 col-xs-12">
                                <label>Product Type</label>
                                <select v-model="model.product_type" @change="filter_procedure('product_type')" class="form-control" ref="product_type">
                                    <option value="">Select</option>
                                    <option v-for="(type, key) in procedures" :value="key" :key="key">{{ key }}</option>
                                    <option value="Others">Others</option>
                                </select>
                            </div>
                            <template v-if="model.product_type == '' || model.product_type == 'Machines'">
                                <div class="form-group col-md-3 col-xs-12">
                                    <label>Product Model</label>
                                    <select v-model="model.product_model" @change="filter_procedure('product_model')" class="form-control" ref="product_model" :disabled="model.product_type == ''">
                                        <option value="">Select</option>
                                        <option v-for="(product, key) in product_models" :value="key" :key="key">{{ key }}</option>
                                        <option value="Others">Others</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-3 col-xs-12">
                                    <label>Item</label>
                                    <select v-model="model.item" @change="filter_procedure('item')" class="form-control" ref="item" :disabled="model.product_type == '' || model.product_model == ''">
                                        <option value="">Select</option>
                                        <option v-for="(item, key) in items" :value="item.item" :key="key">{{ item.item }}</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-3 col-xs-12">
                                    <label>Problem Type</label>
                                    <select v-model="model.web_form_auth" @change="filter_procedure('problem_type')" class="form-control" ref="problem_type" :disabled="model.product_type == '' || model.product_model == '' || model.item == ''">
                                        <option value="">Select</option>
                                        <option v-for="(problem, key) in problem_types" :value="problem.auth" :key="key">{{ problem.title }}</option>
                                        <option value="Others">Others</option>
                                    </select>
                                </div>
                            </template>
                        </div>
                        <template v-if="model.product_type == '' || model.product_type == 'Machines'">
                            <div class="row">
                                <div class="col-md-6 col-xs-12">
                                    <a :href="[procedure_link ? procedure_link : 'javascript:void(0);']" 
                                        v-show="model.product_type != 'Others' && model.web_form_auth != 'Others'" 
                                        id="btnStartTroubleshoot"
                                        class="btn" 
                                        :class="{'btn-success': procedure_link, 'disabled': isLoadingProcedureLink}" 
                                        :target="[procedure_link ? '_blank' : '']"
                                    >
                                        <template v-if="isLoadingProcedureLink"><span class="fa fa-spinner fa-pulse"></span></template>
                                        <template v-else>Start Troubleshooting</template>
                                    </a>
                                </div>
                            </div>
                        </template>
                    </template>
                </card>
            </div>
        </div>

        <template v-if="(model.product_type && model.product_type != 'Machines') || model.web_form_auth == 'Others'">
            <div class="row mt-2">
                <div class="col-md-12">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">Service Ticket</h3>
                                </div>
                            </div>
                        </div>
                        <template>
                            <div class="form-wrap">
                                <form ref="form" @submit.prevent="submit_form">
                                    <div class="row">
                                        <div class="form-group col-md-6 col-xs-12">
                                            <label>Mechanic Name <span class="required-indicator">*</span></label>
                                            <input type="text" class="form-control" ref="mechanic_name" v-model="model.mechanic_name">
                                        </div>
                                        <div class="form-group col-md-6 col-xs-12">
                                            <label>Cell Phone # <span class="required-indicator">*</span></label>
                                            <input type="text" class="form-control" ref="cellphone" v-model="model.cellphone">
                                        </div>
                                        <div class="form-group col-md-6 col-xs-12">
                                            <label>Email <span class="required-indicator">*</span></label>
                                            <input type="text" class="form-control" ref="email" v-model="model.email">
                                        </div>
                                        <div v-if="model.problem_type != 'Others'" class="form-group col-md-6 col-xs-12">
                                            <label>Item</label>
                                            <select class="form-control" ref="item" v-model="model.item">
                                                <option value="">Select</option>
                                                <option v-for="(item, key) in other_items" :value="item.item" :key="key">{{ item.item }}</option>
                                            </select>
                                        </div>
                                        <div class="form-group col-md-6 col-xs-12">
                                            <label>Serial Number <span v-if="model.problem_type == 'Others'" class="required-indicator">*</span></label>
                                            <input type="text" class="form-control" ref="serial_no" v-model="model.serial_no">
                                        </div>
                                        <div class="form-group col-md-6 col-xs-12">
                                            <label>Last Maintenance Date <span class="required-indicator">*</span></label>
                                            <div class="datepicker-wrap" ref="last_maintenance_date">
                                                <date-picker value-type="format" v-model="model.last_maintenance_date" :editable="false" input-class="form-control"></date-picker>
                                            </div>
                                        </div>
                                        <div class="form-group col-md-6 col-xs-12">
                                            <label>Job Name <span class="required-indicator">*</span></label>
                                            <input type="text" class="form-control" ref="job_name" v-model="model.job_name">
                                        </div>
                                        <div class="form-group col-md-6 col-xs-12">
                                            <label>Car # <span class="required-indicator">*</span></label>
                                            <input type="text" class="form-control" ref="car_no" v-model="model.car_no">
                                        </div>
                                        <div class="form-group col-md-6 col-xs-12">
                                            <label>City and State <span class="required-indicator">*</span></label>
                                            <input type="text" class="form-control" ref="city_state" v-model="model.city_state">
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label>Describe the Issue <span class="required-indicator">*</span></label>
                                                <textarea class="form-control" ref="issue" style="height: 7em;" maxlength="150" v-model="model.issue"></textarea>
                                                <small>{{ model.issue.length }} (max 150)</small>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="button-group">
                                                <button class="btn btn-black mb-0" type="submit" :disabled="isSubmitting">
                                                    <template v-if="isSubmitting"><span class="fa fa-spinner fa-pulse"></span></template>
                                                    <template v-else>Submit</template>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </template>
                    </card>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
setTimeout(() => {
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return false
    } else {
        alert('This process is best done with a mobile device in the field.')
    }
}, 1000)

import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

export default {
    components: { 
        DatePicker
    },
    data() {
        return {
            isSubmitting: false,
            isLoadingProcedureLink: false,
            countries: window.countries,
            procedures: [],
            product_models: [],
            items: [],
            other_items: [],
            problem_types: [],
            procedure_link: null,
            model: {
                product_type: '',
                product_model: '',
                item: '',
                problem_type: '',
                web_form_auth: '',
                mechanic_name: '',
                cellphone: '',
                email: '',
                serial_no: '',
                last_maintenance_date: '',
                job_name: '',
                car_no: '',
                city_state: '',
                issue: ''
            }
        }
    },
    mounted() {
        this.get_procedures()
    },
    methods: {
        get_procedures() {
            this.procedures = []

            this.$http.get('/api/st/procedures')
                .then((response) => {
                    this.procedures = response.data.data
                    if(Object.keys(this.procedures).length > 0) {
                        this.get_product_models()
                        let items = this.get_items()
                        if(items) {
                            items.then(() => {
                                this.get_problem_types()
                                this.get_procedure_link()
                            })
                        }
                    }
                })
        },
        get_product_models() {
            this.product_models = []
            this.model.product_model = ''

            if(this.procedures[this.model.product_type] != undefined) {
                this.product_models = this.procedures[this.model.product_type]
            }
        },
        get_items() {
            this.items = []
            this.model.item = ''

            if(this.model.product_type && this.model.product_model && this.model.product_type != 'Others') {
                return this.$http.get('/api/st/items/' + this.model.product_type + '/' + this.model.product_model)
                    .then(response => {
                        this.items = response.data.data
                    })
            } else {
                this.problem_types = []
                this.model.web_form_auth = ''
                this.model.problem_type = ''
                this.procedure_link = ''
            }

            return false
        },
        get_other_items() {
            this.other_items = []
            
            if(this.model.product_type && this.model.product_type != 'Machines') {
                this.$http.get('/api/st/items/' + this.model.product_type)
                    .then(response => {
                        this.other_items = response.data.data
                    })
            }
        },
        get_problem_types() {
            this.problem_types = []
            this.model.web_form_auth = ''
            this.model.problem_type = ''

            if(this.model.product_model && this.model.product_model != 'Others') {
                if(this.product_models[this.model.product_model] != undefined) {
                    this.problem_types = this.product_models[this.model.product_model]
                }
            } else {
                for(let model in this.product_models) {
                    if(this.model.item.indexOf(model) !== -1) {
                        this.problem_types = this.product_models[model]
                        break
                    }
                }
            }
        },
        get_procedure_link() {
            this.procedure_link = ''

            if(this.model.web_form_auth != 'Others') {
                this.problem_types.map(v => {
                    if(v.auth == this.model.web_form_auth) {
                        this.model.problem_type = v.title
                    }
                })

                this.isLoadingProcedureLink = true
                this.$http.post('/api/st/procedure_link', {
                        web_form_auth: this.model.web_form_auth,
                        product_type: this.model.product_type,
                        product_model: this.model.product_model,
                        item: this.model.item,
                        problem_type: this.model.problem_type
                    })
                    .then(response => {
                        this.procedure_link = response.data.data
                        this.isLoadingProcedureLink = false
                    })
                    .catch(() => {
                        this.isLoadingProcedureLink = false
                    })
            } else {
                this.model.problem_type = 'Others'
            }
        },
        filter_procedure(action) {
            switch(action) {
                case 'product_type': {
                    this.get_product_models()
                    this.get_other_items()
                    let items = this.get_items()
                    if(items) {
                        items.then(() => {
                            this.get_problem_types()
                            this.get_procedure_link()
                        })
                    }
                    break;
                }
                case 'product_model': {
                    let items = this.get_items()
                    if(items) {
                        items.then(() => {
                            this.get_problem_types()
                            this.get_procedure_link()
                        })
                    }
                    break;
                }
                case 'item': {
                    this.get_problem_types()
                    this.get_procedure_link()
                    break;
                }
                case 'problem_type': {
                    this.get_procedure_link()
                    break;
                }
            }
        },
        submit_form() {
            this.isSubmitting = true
            this.$http.post('/api/service_tickets', this.model)
                .then(() => {
                    this.reset_form()
                    this.isSubmitting = false
                    this.$router.push('request-support/success')
                })
                .catch(error => {
                    if(error.response.data.message == 'validation_error') {
                        alert('Please fill all required data.')
                        this.validation_error(error.response.data.errors)
                    }
                    this.isSubmitting = false
                })
        },
        validation_error(errors) {
            Array.from(document.querySelectorAll('.hasError')).forEach(function(el) { 
                el.classList.remove('hasError');
            })
                            
            for(let el in this.$refs) {
                if(errors[el] !== undefined) {
                    let ref = this.$refs[el]
                    if(Array.isArray(ref)) {
                        ref = ref[0]
                    }
                    ref.classList.add('hasError')
                    if(Object.keys(errors)[0] == el) {
                        ref.focus()
                        ref.scrollIntoView()
                    }
                }
            }
        },
        reset_form() {
            this.model = {
                product_type: '',
                product_model: '',
                item: '',
                problem_type: '',
                web_form_auth: '',
                mechanic_name: '',
                cellphone: '',
                email: '',
                serial_no: '',
                last_maintenance_date: '',
                job_name: '',
                car_no: '',
                city_state: '',
                issue: ''
            }
        }
    }
};
</script>
<style lang="scss" scoped>
#btnStartTroubleshoot {
    font-size: 20px;
    padding: 0.8em 0.5em;
    width: 100%;
}
.mx-datepicker::v-deep {
    width: 100%;
    .form-control {
        &:read-only {
            background-color: #fff;
        }
    }
}
.card::v-deep {
    .card-header {
        padding: 0.5em 1em;
    }
    .card-body {
        padding: 1em;
    }
}
.success-msg-wrap {
    margin-top: 1em;
    text-align: center;
    img {
        margin-top: 0.5em;
        max-width: 480px;
        width: 100%;
    }
}
.custom-gutter > [class*='col-'] {
    padding-right: 8px;
    padding-left: 8px;
    &:first-child {
        padding-left: 15px;
    }
    &:last-child {
        padding-right: 15px;
    }
}
@media (max-width: 568px) {
    .button-group {
        .btn {
            width: 100%;
        }
    }
}
@media (max-width: 768px) {
    .custom-gutter > [class*='col-'] {
        padding-right: 15px;
        padding-left: 15px;
    }
}
</style>
